import { render, staticRenderFns } from "./fxRatesSetup.vue?vue&type=template&id=581ff230&scoped=true"
import script from "./fxRatesSetup.vue?vue&type=script&lang=js"
export * from "./fxRatesSetup.vue?vue&type=script&lang=js"
import style0 from "./fxRatesSetup.vue?vue&type=style&index=0&id=581ff230&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581ff230",
  null
  
)

export default component.exports